module.exports = __webpack_public_path__ + "hbomaxar-static/media/Witches_Rats_logo.03527ee3.png";